
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41410)"}},[_c('path',{attrs:{"d":"M6.214 7.01a2.571 2.571 0 100-5.143 2.571 2.571 0 000 5.143zM11.357 15.58H1.071v-1.142a5.143 5.143 0 1110.286 0v1.143zM10.785 1.867a2.571 2.571 0 010 5.143M12.614 9.512a5.143 5.143 0 013.314 4.8v1.269h-1.714"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41410"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .152)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    